import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  maintenanceDiv: {
    fontFamily: "Manrope !important",
  },
  shipmentTabs: {
    maxWidth: "100%",
    overflowX: "hidden",
    overflowY: "hidden",
    padding: "16px 32px",
  },
  containerGrid: {
    height: "calc(100vh - 200px)",
    [theme.breakpoints.down("sm")]: {
      height: "100%",
    },
  },
  titlePageContainer: {
    display: "flex",
    position: "relative",
    marginBottom: "1rem",
  },
  titlePage: {
    fontFamily: `'Manrope', sans-serif`,
    color: "#465869",
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: 600,
  },
  tabs: {
    height: "100%",
  },
  rightTabs: {
    height: "100%",
  },
  referenceTitle: {
    color: "#465869",
    fontSize: "14px",
    fontWeight: "bold",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      height: "4px",
      width: "4px",
      backgroundColor: "#465869",
      borderRadius: "50%",
      top: "9px",
      right: "-12px",
    },
  },
  customerTitle: {
    color: "#465869",
    fontSize: "14px",
    fontWeight: "bold",
    marginLeft: "20px",
  },
  containerIdTitle: {
    color: "#465869",
    fontSize: "14px",
    fontWeight: "bold",
  },
  loading: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: 999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100%",
    background: "rgba(0, 0, 0, 0.1)",
  },
  shipmentsHeader: {
    marginBottom: 24,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      "&:nth-last-child(n)": {
        marginTop: "8px",
      },
    },
  },
  shipmentsHeaderBreadcrumb: {
    "& ol": {
      alignItems: "flex-end",
    },
  },
  shipmentsHeaderBreadcrumbTitle: {
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: "bold",
    color: "#38cfc4",
    fontFamily: `'Manrope', sans-serif`,
    "&.active": {
      color: "#465869",
    },
    "&.linkToPeopleTab": {
      cursor: "pointer",
    },
  },
  uiTab: {
    minHeight: "calc(100vh - 310px) !important",
    height: "100% !important",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },
  uiTabTracking: {
    minHeight: "calc(100vh - 310px) !important",
    height: "100% !important",
    paddingTop: "0px",
    paddingBottom: "0px",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },
  uiTabCommunication: {
    height: "calc(100vh - 275px) !important",
  },
  titleData: {
    color: "#465869",
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "13px",
    lineHeight: "16px",
  },
  titleStatusBadge: {
    height: "24px !important",
    width: "fit-content !important",
    fontFamily: "Manrope",
    marginRight: "8px",
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "16px",
  },
  titleDataContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
    },
  },
}));

export default styles;
